var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPromise3 = function SvgPromise3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 61,
    viewBox: "0 0 72 61"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.631 13.364h47.35v44.779h-47.35z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#0c74c6",
    strokeWidth: 3.3,
    d: "M34.584.6h22.679"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.661,
    height: 51.535,
    x: 21.876,
    y: 6.292,
    stroke: "#979797",
    strokeWidth: 1.798,
    rx: 24.331
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.339 20.973h19.277v21.573H11.339z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeWidth: 4.315,
    d: "M15.308 31.76h21.544M5.67 38.95h21.544M5.67 24.569h21.544"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c74c6",
    strokeWidth: 3.3,
    d: "M45.357 15.58v18.577M44.625 36.04l7.648 7.168"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.159,
    height: 50.033,
    x: 22.627,
    y: 7.043,
    stroke: "#0c74c6",
    strokeWidth: 3.3,
    rx: 23.58
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 20.374h37.986v21.573H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c74c6",
    strokeWidth: 3.3,
    d: "M15.308 32.36h21.544M5.67 39.55h21.544M5.67 24.569h21.544"
  })))));
};
export default SvgPromise3;